
export type SimpleTestBody = {
  /** 테스트 메시지 */
  message: string;
};
